const vhUnit = () => {
	document.documentElement.style.setProperty(
		'--vh',
		`${window.innerHeight * 0.01}px`
	);
};

export const headerHeightVar = () => {
	document.documentElement.style.setProperty(
		'--headerHeight',
		`${
			document.querySelector('.main-header').getBoundingClientRect()
				.height
		}px`
	);
};

export default vhUnit;
